"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  RunningEnv: true,
  ready: true,
  getRunningEnv: true
};
exports.getRunningEnv = exports.ready = exports.RunningEnv = void 0;

var _bridge = require("./bridge");

var _api = require("./api");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _api[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});
var RunningEnv;
exports.RunningEnv = RunningEnv;

(function (RunningEnv) {
  RunningEnv["Unknown"] = "unknown";
  RunningEnv["Node"] = "node";
  RunningEnv["Browser"] = "browser";
  RunningEnv["App"] = "app";
})(RunningEnv || (exports.RunningEnv = RunningEnv = {}));

var runningEnv = RunningEnv.Unknown;

var ready = function ready(callback) {
  if (typeof window === 'undefined') {
    runningEnv = RunningEnv.Node;
    return Promise.resolve({
      runningEnv: runningEnv
    });
  } else if (typeof window.getCurrentRunEnv === 'undefined') {
    runningEnv = RunningEnv.Browser;
    return Promise.resolve({
      runningEnv: runningEnv
    });
  }

  return new Promise(function (resolve) {
    window.jsBridge = _bridge.JsBridge.getInstance();
    window.getCurrentRunEnv.postMessage('auth');

    window.modouEnvJsonpCallback = function modouEnvJsonpCallback(json) {
      runningEnv = RunningEnv.App;
      var authData = {
        token: json.token,
        engineCode: json.engineCode,
        memberId: json.memberId,
        runningEnv: runningEnv,
        openUrlType: json.openUrlType
      };

      if (typeof callback === 'function') {
        callback(authData);
      }

      resolve(authData);
    };
  });
};

exports.ready = ready;

var getRunningEnv = function getRunningEnv() {
  return runningEnv;
};

exports.getRunningEnv = getRunningEnv;